import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { XStack, YStack } from "tamagui";
import { z } from "zod";

import { useUpdateUserProfile } from "@/api/mutations/userProfile";
import { useGetUserProfile } from "@/api/queries/userProfile";
import { Select } from "@/components";
import SkipOrSubmit from "@/conversation/AskUserQuestionsPanel/SkipOrSubmit";
import { US_STATES } from "@/settings/constants";

const currentStateSchema = z.object({
  state: z.string().min(1, "Please select a state"),
});

type CurrentStateForm = z.infer<typeof currentStateSchema>;

export default function CurrentStateStep({
  onSubmitted,
}: {
  onSubmitted: () => void;
}) {
  const { data: profile } = useGetUserProfile();
  const { mutate: updateUserProfile, isPending } = useUpdateUserProfile();

  const { control, handleSubmit } = useForm<CurrentStateForm>({
    resolver: zodResolver(currentStateSchema),
    mode: "onBlur",
    values: { state: profile?.residingState ?? "" },
  });

  const onSubmit = handleSubmit(({ state }) => {
    updateUserProfile(
      { data: { residingState: state } },
      { onSuccess: onSubmitted },
    );
  });

  return (
    <>
      <YStack paddingHorizontal="$150">
        <Controller
          control={control}
          name="state"
          render={({ field, fieldState }) => (
            <Select
              ref={field.ref}
              name={field.name}
              label="State"
              items={US_STATES}
              value={field.value ?? ""}
              onValueChange={field.onChange}
              placeholder="State"
              errorText={fieldState.error?.message}
            />
          )}
        />
      </YStack>
      <XStack
        justifyContent="flex-end"
        paddingHorizontal="$150"
        marginTop="$250"
        paddingBottom="$150"
      >
        <SkipOrSubmit
          showSkip={false}
          showSubmit
          submitDisabled={isPending}
          isLast
          onSkip={onSubmit}
          onSubmit={onSubmit}
        />
      </XStack>
    </>
  );
}
